import { makeStyles } from '@material-ui/core/styles';
import { replaceKeysLabelText } from '../../../../utils/utility';
import { pxToRem } from '../../../../styles/themes/vad/constants';
import { borderRadius } from '../../../../styles/themes/vad/borderRadius';

const useStyles = makeStyles(theme => {
  return {
    '@global': {
      '.sticky:not(.ghostdiv-reached)': {
        background: '#FCEFDE',
        '& .sticky-hidden': {
          display: 'none',
        },
        '& .section-container': {
          padding: '0 5.5%',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'nowrap',
          [theme.breakpoints.up('lg')]: {
            flexWrap: 'nowrap',
          },
        },
        '& .page-title': {
          paddingTop: pxToRem(30),
          paddingBottom: pxToRem(30),
          margin: 0,
          overflow: 'hidden',
          [theme.breakpoints.down('md')]: {
            width: '35%',
          },
          '& div': {
            maxWidth: '100%',
            '& h1': {
              textOverflow: 'ellipsis',
              maxWidth: '100%',
              overflow: 'hidden',
              whiteSpace: 'nowrap',
            },
          },

        },
        '& .MuiTypography-h2': {
          ...theme.typography.h5Bold,
          margin: 0,
          paddingRight: pxToRem(20),
        },
        '& .detail-section': {
          padding: `0`,
          display: 'flex',
          marginBottom: '0',
          width: 'auto',
          flexShrink: 0,
          [theme.breakpoints.down('md')]: {
            flexDirection: 'row',
            width: '63%',
          },
          [theme.breakpoints.down('sm')]: {
            width: 'auto',
          },
          '& .desktopSectionWrap': {
            [theme.breakpoints.down('md')]: {
              paddingBottom: 0,
              width: 'auto',
              flex: '0 0 auto',
              '&:before': {
                display: 'none'
              },
            },
          },
          '& .contacts-section': {
            [theme.breakpoints.down('md')]: {
              paddingTop: 0,
              '& .ticketCta': {
                ...theme.mixins.marginLeft(pxToRem(24) + ' !important'),
              }
            },
          }
        },
        '& .cta-wrap': {
          display: 'flex',
          alignItems: 'center',
          width: '100%',
          paddingTop: theme.spacing(2),
          paddingBottom: theme.spacing(2),
          justifyContent: 'space-between',
        },
        '& .stickyFavoriteIcon': {
          [theme.breakpoints.up('lg')]: {
            ...theme.mixins.marginRight(pxToRem(20)),
          },
        },
        [theme.breakpoints.down('sm')]: {
          position: 'static',
          display: 'block !important',
          transition: 'none',
        },
      },
      '.mobile-sticky-bottom:not(.ghostdiv-reached)': {
        [theme.breakpoints.down('md')]: {
          background: '#FFF',
        },
        '& .cta-wrap': {
          [theme.breakpoints.down('md')]: {
            padding: `${pxToRem(12)} 0`
          },
          '& button': {
            height: pxToRem(40),
            backgroundColor: '#FF8707'
          }
        },
        '& .heartMobile': {
          '& .heartIcon': {
            '@media (max-width: 768px)': {
              position: 'relative',
              display: 'block',
              backgroundColor: '#F7F7F7',
              width: pxToRem(40),
              height: pxToRem(40),
              margin: 0,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              borderRadius: '50%',
            },
            '&.selected': {
              '& svg': {
                '& path': {
                  fill: 'rgb(255, 135, 7);'
                }
              }
            },
            '& svg': {
              width: pxToRem(24),
              height: pxToRem(24),
            }
          }
        },
        '&.sticky': {
          position: 'fixed'
        },
        '& .date': {
          display: 'block !important',
          [theme.breakpoints.down('md')]: {
            fontSize: pxToRem(24),
            lineHeight: pxToRem(40),
          },

        },
        '& .priceTag': {
          display: 'flex !important'
        },
        '& .page-title': {
          fontSize: pxToRem(72),
          lineHeight: pxToRem(80),
          margin: '0 5.5%',
          fontFamily: theme.custom.fontFamily.primaryBold,
          marginBottom: pxToRem(64),
          [theme.breakpoints.down('md')]: {
            display: 'none',
            fontSize: pxToRem(32),
            lineHeight: pxToRem(40),
          },
        },
        '& .desktopSectionWrap': {
          display: 'none',
        }
      },
      '.ghostdiv-reached': {
        '& .date': {
          display: 'block !important',
          [theme.breakpoints.down('md')]: {
            fontSize: pxToRem(24),
            lineHeight: pxToRem(40),
          },
          '@media (max-width: 600px)': {
            fontSize: pxToRem(20),
            lineHeight: pxToRem(30),
          },
        },
        '& .priceTag': {
          display: 'flex !important'
        },
        '& .page-title': {
          fontSize: pxToRem(72),
          lineHeight: pxToRem(80),
          margin: '0 5.5%',
          fontFamily: theme.custom.fontFamily.primaryBold,
          marginBottom: pxToRem(64),
          [theme.breakpoints.down('md')]: {
            display: 'none',
            fontSize: pxToRem(32),
            lineHeight: pxToRem(40),
          },
        }
      },
      '.sticky.ghostdiv-reached': {
        position: 'static',
        transform: 'none',
        transition: 'none',
      },
    },
    pageTitle: {
      marginBottom: theme.spacing(3),
      [theme.breakpoints.up('lg')]: {
        marginBottom: theme.spacing(6),
      },
      '& .rating': {
        alignItems: 'center',
        verticalAlign: 'top',
        border: `1px solid ${theme.mixins.Grey(500)}`,
        borderRadius: borderRadius.b4Rem,
        ...theme.mixins.marginLeft(pxToRem(10)),
        ...theme.mixins.paddingLR(3, 3),
        [theme.breakpoints.up('lg')]: {
          padding: `${pxToRem(2)} ${pxToRem(5)}`,
          marginTop: theme.spacing(2),
          '.sticky:not(.ghostdiv-reached) &': {
            marginTop: theme.spacing(0),
          },
        },
        '& svg': {
          height: pxToRem(13),
          width: pxToRem(13),
          [theme.breakpoints.up('lg')]: {
            height: theme.spacing(2),
            width: theme.spacing(2),
          },
        },
        '& .MuiTypography-labelRegular': {
          ...theme.typography.body2Bold,
          margin: 0,
        },
      },
      '& h1': {
        ...theme.palette.common.ellipsis(2),
      }
    },
    location: {
      marginBottom: theme.spacing(3),
      color: theme.palette.text.tertiary,
      [theme.breakpoints.up('lg')]: {
        marginBottom: theme.spacing(2),
      },
    },
    detailSection: {
      padding: `${pxToRem(26)} 5.5%`,
      alignItems: 'center',
      justifyContent: 'space-between',
      flexWrap: 'nowrap',
      backgroundColor: '#FCEFDE',

      '& .contacts-section': {
        '& .ticketCta': {
          backgroundColor: theme.mixins.SeaGreen(),
          ...theme.mixins.marginLeft(pxToRem(24)),
          textWrap: 'nowrap',
          '& .MuiButton-label': {
            '& .MuiButton-endIcon': {
              ...theme.mixins.marginLeft(pxToRem(8) + ' !important'),
            },
            [theme.breakpoints.down('md')]: {
              '& .btn-txt': {
                fontSize: pxToRem(16),
              }
            }
          }
        }
      },

      [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
        padding: pxToRem(24),
        '& .desktopSectionWrap': {
          width: '100%',
          justifyContent: 'space-between',
          paddingBottom: pxToRem(16),
          position: 'relative',
          '@media (max-width: 600px)': {
            paddingBottom: pxToRem(24),
          },

          '&:before': {
            position: 'absolute',
            width: '100%',
            height: '1px',
            backgroundColor: '#FF8707',
            content: '""',
            bottom: 0,
            left: 0,
          },
        },
        '& .contacts-section': {
          paddingTop: pxToRem(16),
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
          '& div': {
            display: 'none'
          },
          '& .priceTag': {
            fontSize: pxToRem(16),
            lineHeight: pxToRem(40),
            // paddingBottom: pxToRem(16),

            '@media (max-width: 600px)': {
              fontSize: pxToRem(12),
            },

            '& .MuiTypography-h5': {
              fontSize: pxToRem(24),
              lineHeight: pxToRem(40),
              ...theme.mixins.marginLeft(pxToRem(4)),
            },
          },
          '& .ticketCta': {
            ...theme.mixins.marginLeft(0 + ' !important'),
            minHeight: pxToRem(48),
            '@media (max-width: 600px)': {
              minHeight: pxToRem(40),
            },
            '& .MuiButton-label': {
              justifyContent: 'space-between'
            }
          }
        }
      },
      [theme.breakpoints.down('sm')]: {
        '& .contacts-section': {
          flexDirection: 'row',
          alignItems: 'flex-start',
          justifyContent: 'space-between',
          width: '100%',
          '& div': {
            display: 'none'
          },
        }
      },
      [theme.breakpoints.up('lg')]: {
        backgroundColor: '#FCEFDE',
        display: 'flex',
        flexDirection: 'row',
        marginBottom: pxToRem(64),
        '.sticky:not(.ghostdiv-reached) &:not(.btn-present) .contacts-section': {
          ...theme.mixins.paddingRight(0),
          ...theme.mixins.borderRight('none'),
        },
      },
      '& .desktopSectionWrap': {
        display: 'flex',
        alignItems: 'center',
        [theme.breakpoints.down('md')]: {
          flexDirection: 'row',
        },
        '@media (max-width: 600px)': {
          flexDirection: 'column',
          alignItems: 'flex-start',
        },
        '& .fav-icon-iteranary-container': {
          display: 'flex',
          alignItems: 'center',
          '@media (max-width: 600px)': {
            width: '100%',
          },

          '& .heartIcon': {
            [theme.breakpoints.down('md')]: {
              height: pxToRem(48),
              width: pxToRem(48),
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              ...theme.mixins.marginLeft(0),
            },
            '@media (max-width: 600px)': {
              height: pxToRem(40),
              width: pxToRem(40),
            },
          },
        },
        '& .sticky-iteranary-btn': {
          minHeight: pxToRem(48),
          backgroundColor: 'transparent',
          border: "2px solid #000",
          transition: "background-color ease 0.25s, border ease 0.25s",
          ...theme.mixins.marginLeft(16),
          [theme.breakpoints.down('md')]: {
            height: pxToRem(40),
            // minHeight: 'auto',
            flexGrow: 1,
            textWrap: 'nowrap',
          },
          '@media (max-width: 600px)': {
            textWrap: 'wrap',
            minHeight: pxToRem(40),
          },
          '&:hover': {
            backgroundColor: '#0D746D',
            border: "2px solid #0D746D",
            '& .btn-txt': {
              color: "#fff !important",
            },
            '& .MuiButton-endIcon': {
              '& path': {
                fill: "#fff !important",
              },
            },
          },
          '& .MuiButton-label': {
            display: 'flex',
            flexDirection: 'row-reverse',
            '& .btn-txt': {
              color: "#000",
              fontFamily: theme.custom.fontFamily.primaryRegular,
              fontSize: pxToRem(16),
              textWrap: 'nowrap',
            },
            '& .MuiButton-endIcon': {
              marginLeft: theme.direction === 'rtl' ? `${pxToRem(10)} !important` : '0 !important',
              marginRight: theme.direction === 'rtl' ? '0 !important' : `${pxToRem(10)} !important`,
              [theme.breakpoints.down('md')]: {
                marginRight: theme.direction === 'rtl' ? '0 !important' : `${pxToRem(10)} !important`,
              },
            },
          }
        },
        '& .heartIcon': {
          ...theme.mixins.marginLR(pxToRem(16), 0),
          position: 'relative',
          display: 'flex',
          border: '2px solid #000000',
          padding: pxToRem(10),
          borderRadius: '50%',
          marginTop: 0,
          transition: 'ease 0.5s all',
          [theme.breakpoints.down('md')]: {
            padding: pxToRem(6),
          },
          '& svg': {
            '& path': {
              transition: 'ease 0.5s all',
            }
          },
          '&:not(.selected):hover': {
            [theme.breakpoints.up('lg')]: {
              backgroundColor: '#0D746D',
              borderColor: '#0D746D',
              '& svg': {
                '& path': {
                  fill: '#0D746D',
                  stroke: '#fff',
                },
              },
            },
          },
          '&.selected': {
            backgroundColor: '#009086',
            borderColor: '#009086',
            '& svg': {
              '& path': {
                fill: '#fff',
                stroke: '#fff',
              }
            }
          },
          '& svg': {
            width: pxToRem(24),
            height: pxToRem(24),
            '& path': {
              stroke: '#000',
              fill: 'transparent'
            }
          }
        },
      },
      '& .date': {
        display: 'none',

        '@media (max-width: 600px)': {
          lineHeight: pxToRem(30),
          marginBottom: pxToRem(16),
        },
      }
    },
    ctaWrapper: {
      display: 'none',
      [theme.breakpoints.down('md')]: {
        '& .primaryCTA': {
          whiteSpace: 'nowrap',
        },
      },
      [theme.breakpoints.up('lg')]: {
        display: 'flex',
        alignItems: 'center',
      },
      '& .secondaryCTA .MuiButton-endIcon': {
        display: 'none',
      },
    },
    contacts: {
      display: 'flex',
      // flexDirection: 'column',
      // width: '100%',
      // paddingBottom: theme.spacing(1),
      '& .heartIcon': {
        position: 'relative',
        display: 'flex',
        border: '2px solid #000000',
        padding: pxToRem(10),
        borderRadius: '50%',
        marginTop: 0,
        marginRight: 0,
        display: 'none',
        '&.selected': {
          '& svg': {
            '& path': {
              fill: '#FF8707'
            }
          }
        },
        '& svg': {
          width: pxToRem(24),
          height: pxToRem(24),
          '& path': {
            stroke: '#000',
            fill: 'transparent'
          }
        }
      },
      '&.contacts-section': {
        '@media (max-width: 600px)': {
          paddingTop: pxToRem(24),
        },
        '& .priceTag': {
          display: 'flex',
          alignItems: 'center',
          lineHeight: pxToRem(40),
          display: 'none',
          '& .price_tag_value': {
            ...theme.mixins.marginLeft(12),
            fontSize: pxToRem(32),
            lineHeight: pxToRem(40),

            [theme.breakpoints.down('md')]: {
              fontSize: pxToRem(24),
            },
            '@media (max-width: 600px)': {
              ...theme.mixins.marginLeft(4),
              fontSize: pxToRem(24),
            },
          }
        },
      },
      '& .ticketCta': {
        minHeight: pxToRem(48),
        ...theme.mixins.marginLeft(12)
      },
      [theme.breakpoints.up('lg')]: {
        width: 'auto',
        flexDirection: 'row',
        alignItems: 'center',
        paddingBottom: theme.spacing(0),
      },
    },
    contactTxt: {
      color: props =>
        props.themeColor &&
        replaceKeysLabelText({ value: props.themeColor }, ['1']).value,
      textDecoration: 'none',
      paddingBottom: theme.spacing(3),
      [theme.breakpoints.up('lg')]: {
        display: 'inline',
        ...theme.mixins.marginRight(pxToRem(30)),
        paddingBottom: '0',
        '&:last-child': {
          ...theme.mixins.marginRight(0),
        },
        '&:hover': {
          color: theme.palette.primary.main,
          textDecoration: 'underline',
        },
      },
    },
    socialIcons: {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      [theme.breakpoints.up('lg')]: {
        width: 'auto',
      },
      '& a': {
        ...theme.mixins.marginRight(theme.spacing(2)),
        '&:last-child': {
          ...theme.mixins.marginRight(0),
        },
      },
      '& .MuiIconButton-root': {
        padding: theme.spacing(1),
        backgroundColor: theme.mixins.Grey(100),
        height: theme.spacing(5),
        width: theme.spacing(5),
        '&:hover': {
          backgroundColor: props =>
            props.themeColor &&
            replaceKeysLabelText({ value: props.themeColor }, ['1']).value,
          '& svg': {
            color: theme.palette.primary.contrastText,
            '&.twitter': {
              width: pxToRem(24),
              height: pxToRem(24),
              '& path': {
                fill: '#fff',
              },
            },
          },
        },
        '&.facebookIcon svg': {
          height: pxToRem(20),
          width: pxToRem(20),
        },
        '& svg': {
          color: theme.palette.primary.main,
          '&.twitter': {
            width: pxToRem(24),
            height: pxToRem(24),
            '& path': {
              fill: '#000',
            },
          },
        },
      },
    },
    verticalBar: {
      width: '2px',
      height: '24px',
      border: `1px solid ${theme.palette.common.DisabledGrey}`,
      ...theme.mixins.marginLeft(12),
      ...theme.mixins.marginRight(30),
      [theme.breakpoints.down('md')]: {
        display: 'none',
      },
    },
    ml30: {
      ...theme.mixins.marginLeft(pxToRem(30)),
    },
    dflex: {
      display: 'flex'
    },
    vdiv: {
      [theme.breakpoints.down('md')]: {
        ...theme.mixins.borderRight(`1px solid ${theme.palette.common.DisabledGrey}`),
        ...theme.mixins.marginRight(pxToRem(13.5)),
        height: '40px'
      },
    },
    modalPopUp: {
      backgroundColor: theme.mixins.White(),
      '& .MuiDialog-scrollPaper': {
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
      },
      '& .MuiPaper-root': {
        margin: '0',
        height: '100%',
        width: '100%',
        '& > button': {
          padding: 0,
          '& svg': {
            color: theme.mixins.Black(),
            width: theme.spacing(3),
            height: theme.spacing(3),
          },
        },
      },
      '& .MuiBackdrop-root': {
        backgroundColor: 'transparent',
      },
      '& .MuiDialogTitle-root': {
        padding: 0,
      },
      '& .MuiDialogContent-root': {
        margin: `${theme.spacing(8)} ${theme.spacing(3)} 0`,
        padding: 0,
        color: theme.mixins.Black(),
        '& .MuiTypography-h2': {
          ...theme.mixins.marginLeft(0),
        },
        '& button': {
          position: 'absolute',
          bottom: theme.spacing(6),
          ...theme.mixins.left(theme.spacing(0)),
        },
      },
      '& .detail-section': {
        display: 'flex',
        flexDirection: 'column',
      },
      '& .mobile-cta-wrap': {
        display: 'flex',
        position: 'absolute',
        bottom: '0',
      },
    },
  };
});

export default useStyles;
